import React from 'react';
import { motion } from 'framer-motion';

export const EASE = [0.22, 1, 0.36, 1];

// NOTE: whileInView must live on the untransformed mask parent — observing
// the translated child fails because it's clipped by its own overflow-hidden mask.
export function MaskedLines({ lines, delay = 0 }) {
  return (
    <>
      {lines.map((line, i) => (
        <motion.span
          key={i}
          className="block overflow-hidden"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.35 }}
        >
          <motion.span
            className="block"
            variants={{
              hidden: { y: '112%' },
              visible: {
                y: '0%',
                transition: { duration: 0.85, ease: EASE, delay: delay + i * 0.13 },
              },
            }}
          >
            {line}
          </motion.span>
        </motion.span>
      ))}
    </>
  );
}

export function Reveal({ children, delay = 0, y = 24, className }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.75, ease: EASE, delay }}
    >
      {children}
    </motion.div>
  );
}
